'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Flex = require('./Flex');

var _Flex2 = _interopRequireDefault(_Flex);

var _FlexItem = require('./FlexItem');

var _FlexItem2 = _interopRequireDefault(_FlexItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Flex2['default'].Item = _FlexItem2['default'];
exports['default'] = _Flex2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/flex/index.js
// module id = 1109
// module chunks = 0 2 3 4 5 6 7 8 9 10 12 13 16 18 19 20 21 22 23 24 25 26 27 28 29 30 32 33 34 37 38 39 40 41 42 43 44 45